  
import { Link } from "react-router-dom";
 
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";
 
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
 
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
// import bgImage from "assets/images/bg-sign-up-cover.jpeg";
import { useEffect, useState } from "react";
import bgImage from "assets/ClinicImages/PT1.jpg";

import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import CountrySelector from "./CountrySelector";
import UsersApi from "Classes/API/UsersApi";
import CreateUserReq from "../../../Classes/Models/Requests/Users/CreateUserReq";
import { Route, Redirect, Navigate, RouteComponent } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';

function Cover() {
  const [Email, SetEmail] = useState('')
  const [Username, SetUsername] = useState('')
  const [Address, SetAddress] = useState('')
  const [Nationality, SetNationality] = useState('')

  const [Number, SetNumber] = useState('')

  const [Password, SetPassword] = useState('')
  const [ConfirmPassword, SetConfirmPassword] = useState('')

  const [ErrorText, SetErrorText] = useState('')

  const [GoHome, SetGoHome] = useState(false)

  const auth = getAuth();
  const [user, loading, error] = useAuthState(auth);


  useEffect(() => {

    console.log(user, loading)
    if(user){
 
      SetGoHome(true)
    }
  },[user, loading])
  
  


  const onSubmit = async () => {
    var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);

    if (!pattern.test(Email)) {
      SetErrorText("لو سمحت أدخل بريد إليكتروني صالح");
      return;
    }

    if (Username.length == 0) {
      SetErrorText("الرجاء ادخال اسم المستخدم");
      return;
    }

    if (Number.length == 0) {
      SetErrorText("الرجاء إدخال رقم هاتف");
      return;
    }

    
    if (Address.length == 0) {
      SetErrorText("Address");
      return;
    }

    
    if (Nationality.length == 0) {
      SetErrorText("Nationality");
      return;
    }

    if (Password !== ConfirmPassword) {
      SetErrorText("كلمة المرور غير مطابقة");
      return;
    }

    if (Password.length < 6) {
      SetErrorText("يجب أن تتكون كلمة المرور من 6 أحرف على الأقل")
      return;
    }

    createUserWithEmailAndPassword(auth, Email, Password)
      .then(async (userCredential) => {
        // Signed in 
        let req = new CreateUserReq();
        const user = userCredential.user;

        req.FirebaseId = user.uid
        req.Email = Email;
        req.Address = Address;
        req.Name = Username;
        req.Number = Number;
        req.Nationality = Nationality;
        req.UserType = "UnAssigned";
        req.isActivated = false;
        req.isSoftDeleted = false;
        req.isAssessmentTherapist = false;
 
        var res = await UsersApi.CreateUser(req);
        
        if(res.status == "Success"){
          SetGoHome(true)
        }


      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        SetErrorText(errorMessage)
        console.log(error)
        // ..
      });
  }
  return (
    
    <CoverLayout image={bgImage}>
      {
          
          GoHome && <Navigate to="/"/> 
      }
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Join us today
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Enter your information to register
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput onChange={e => SetEmail(e.target.value)} type="email" label="Email" variant="standard" fullWidth />
            </MDBox>

            <MDBox mb={2}>
              <MDInput onChange={e => SetUsername(e.target.value)} type="text" label="Name" variant="standard" fullWidth />
            </MDBox>
            <MDBox mb={2}>
              <MDInput onChange={e => SetNumber(e.target.value)} type="tel" label="Phone" variant="standard" fullWidth />
            </MDBox>
            <MDBox mb={2}>
              <MDInput onChange={e => SetAddress(e.target.value)} type="text" label="Address" variant="standard" fullWidth />
            </MDBox>


            <MDBox mb={2}>
              <MDTypography variant="overline" color={"text"}>Nationality</MDTypography>
              <CountrySelector SetNationality={SetNationality} />
            </MDBox>
            <MDBox mb={2}>
              <MDInput onChange={e => SetPassword(e.target.value)} type="password" label="Password" variant="standard" fullWidth />
            </MDBox>

            <MDBox mb={2}>
              <MDInput onChange={e => SetConfirmPassword(e.target.value)} type="password" label="Confirm Password" variant="standard" fullWidth />
            </MDBox>

            <MDBox mt={4} mb={1}>
            <MDTypography variant="overline" color={"error"}>{ErrorText}</MDTypography>

            </MDBox>

            <MDBox mt={4} mb={1}>
              <MDButton onClick = {() => onSubmit()} variant="gradient" color="info" fullWidth>
                Sign Up
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Already have an account?{" "}
                <MDTypography
                  component={Link}
                  to="/authentication/sign-in"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Sign In
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default Cover;
